export const enum CellStates {
  Dead,
  Alive,
}
